import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';

export default function GameCategories() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            游戏分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型浏览，快速找到你喜欢的网页游戏
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 text-center hover:border-primary-300/40 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-xl bg-accent-100/70 flex items-center justify-center group-hover:bg-accent-200/70 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-2 leading-relaxed">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.count} 款游戏
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}